import { connect } from 'react-redux';

import SelectGlobalClassroom from '../components/SelectGlobalClassroom';

import { fetchClassroomsBySchool, selectClassroom } from '../actions/classrooms';
import { selectStudent } from '../actions/students';

const mapStateToProps = (state) => {
	return {
		classrooms: state.classrooms.list,
		isFetchingClassrooms: state.classrooms.isFetching,
		isFetchingDistricts: state.districts.isFetching,
		isFetchingSchools: state.schools.isFetching,
		selectedClassroom: state.classrooms.selected,
		selectedSchool: state.schools.selected
	};
};

const mapDispatchToProps = {
	fetchClassroomsBySchool,
	selectClassroom,
	selectStudent
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectGlobalClassroom);



// WEBPACK FOOTER //
// ./frontend/a2i/js/containers/SelectGlobalClassroom.jsx